import { CrudForm } from "#pub/crud/index.js";
import TokenFormConfig from "./config/TokenFormConfig.js";

export default {

    extends: CrudForm,

    name: 'TokenForm',

    config: TokenFormConfig
}